import { register } from '../functions/templates'

export const useCustomTemplate = {
  created: function () {
    const template = this.config.useCustomTemplate && this.config.customTemplate
      ? this.config.customTemplate
      : this.defaultTemplate

    if (!template) {
      return
    }

    register({
      template,
      name: this.templateName,
      group: this.templateGroup,
    })
  }
}
